import React, { createContext, useState, useContext, ReactNode,useEffect } from 'react';

type Theme = 'light' | 'dark';

interface ThemeContextProps {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<Theme>(
    localStorage.getItem('theme') as Theme || 'dark'
  );
  
  useEffect(() => {
    // Apply the theme to the HTML element on mount
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

const toggleTheme = () => {
  const newTheme = theme === 'light' ? 'dark' : 'light';
  setTheme(newTheme);
  localStorage.setItem('theme', newTheme); // Save theme preference to localStorage
  document.documentElement.setAttribute('data-theme', newTheme); // Update the HTML attribute
};
 
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};